import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import useChaseListNavigate from "../hooks/useChaseListNavigate";
import { useSelector } from "react-redux";
function Footer() {
    var chaseListNavigate = useChaseListNavigate();
    var currentPage = useSelector(function (state) { return state.site.currentPage; });
    var pageChangeHandle = function (path, isExternal) {
        if (isExternal === void 0) { isExternal = false; }
        if (isExternal) {
            window.open(path, "_blank");
            return;
        }
        chaseListNavigate(path);
    };
    var navItems = [
        {
            path: "/#/bb-pilots",
            imgSrc: "./images/globe-icon-gray.png",
            alt: "BB Pilots",
            label: "BB Pilots",
            imgClass: "object-contain aspect-[2.42] rounded-[40px] w-[58px]",
            divClass: "flex flex-col items-center font-medium w-[59px]",
        },
        {
            path: "/#/schedule",
            imgSrc: "./images/ship-icon-gray.png",
            alt: "Schedule",
            label: "Schedule",
            imgClass: "object-contain w-6 aspect-square",
            divClass: "flex flex-col items-center whitespace-nowrap w-[59px]",
        },
        {
            path: "https://www.miamidade.gov/Apps/Seaport/dailydock/Default.aspx",
            isExternal: true,
            imgSrc: "./images/doc-icon.png",
            alt: "Docking Report",
            label: "Docking Report",
            imgClass: "object-contain self-center aspect-square",
            divClass: "flex flex-col",
        },
        {
            path: "/#/work-order",
            imgSrc: "./images/user-fill-icon.png",
            alt: "Work Order",
            label: "Work Order",
            imgClass: "object-contain w-6 aspect-square",
            divClass: "flex flex-col items-center",
        },
    ];
    return (_jsx("div", { className: "lg:hidden fixed z-10 w-full bottom-0 flex gap-2.5 justify-center px-5 py-2 h-[80px] mt-0 text-xs tracking-normal text-center bg-white border-t border-slate-800 border-opacity-10 text-neutral-400", children: _jsx("div", { className: "flex flex-col flex-1 shrink justify-between w-full basis-0 min-w-[240px]", children: _jsx("div", { className: "flex justify-between items-start w-full", children: navItems.map(function (item, index) {
                    var isActive = currentPage === item.path;
                    return (_jsxs("div", { onClick: function () {
                            return item.path &&
                                pageChangeHandle(item.path, item.isExternal);
                        }, className: "".concat(item.divClass, " ").concat(isActive ? "text-blue-400" : ""), children: [_jsx("img", { loading: "lazy", src: isActive
                                    ? item.imgSrc.replace("-gray.png", "-blue.png")
                                    : item.imgSrc, alt: item.alt, className: item.imgClass }), _jsx("div", { className: "mt-1", children: item.label })] }, index));
                }) }) }) }));
}
export default Footer;
